// extracted by mini-css-extract-plugin
export default {"headerColumn":"table-view-head_headerColumn__zlk76"};